import request from '@/plugin/axios'

export function queryBuild (params) {
  return request({
    url: '/v1/electricity/webArchivemanageBuildingmanage/queryBuild',
    method: 'get',
    params
  })
}
export function queryByBuild (params) {
  return request({
    url: '/v1/electricity/webArchivemanageBuildingmanage/queryByBuild',
    method: 'get',
    params
  })
}
export function queryBuildTree (params) {
  return request({
    url: '/v1/electricity/webArchivemanageBuildingmanage/queryBuildTree',
    method: 'get',
    params
  })
}

export function updateBuild (data) {
  return request({
    url: '/v1/electricity/webArchivemanageBuildingmanage/updateBuild',
    method: 'put',
    data
  })
}

export function saveBuild (data) {
  return request({
    url: '/v1/electricity/webArchivemanageBuildingmanage/saveBuild',
    method: 'post',
    data
  })
}
export function deleteBuild (data) {
  return request({
    url: '/v1/electricity/webArchivemanageBuildingmanage/deleteBuild',
    headers: {
      'Content-Type': 'x-www-form-urlencoded'
    },
    method: 'delete',
    params: data
  })
}
